// resources/js/store/index.js
import { createStore } from 'vuex';
import auth from './modules/auth';
import customer from './modules/customer';
import quotes from './modules/quotes';

/**
 * Vuex Store
 * Using a modular approach for better organization and maintainability
 */
export default createStore({
  modules: {
    auth,
    customer,
    quotes
  },
  // Root state - for app-wide configuration
  state() {
    return {
      appVersion: '1.0.0',
      appName: 'Insurance Express',
      maintenanceMode: false
    };
  },
  mutations: {
    SET_MAINTENANCE_MODE(state, isInMaintenance) {
      state.maintenanceMode = isInMaintenance;
    }
  },
  actions: {
    /**
     * Initialize the app
     * This is called when the app starts up to set up initial state
     */
    initializeApp({ dispatch }) {
      // Generate a session ID for tracking user sessions
      dispatch('auth/generateSessionId');
    },
    
    /**
     * Set maintenance mode
     */
    setMaintenanceMode({ commit }, isInMaintenance) {
      commit('SET_MAINTENANCE_MODE', isInMaintenance);
    }
  },
  getters: {
    /**
     * Get app version
     */
    appVersion: state => state.appVersion,
    
    /**
     * Get app name
     */
    appName: state => state.appName,
    
    /**
     * Check if app is in maintenance mode
     */
    isInMaintenanceMode: state => state.maintenanceMode
  }
});
